// this script moves the related products and reviews section in the product info container

document.addEventListener('DOMContentLoaded', function () {
  const related = document.querySelector('.related-products');
  const reviews = document.querySelector('#bundle-product_reviews');
  const infoContainer = document.querySelector('.product__info-container');
  const bottomDetailsMobile = document.querySelector('.product-bottom-details.mobile');

  function moveElementsToMobileContainers() {
    if (window.innerWidth <= 749) {
      if (related && infoContainer && !infoContainer.contains(related)) {
        infoContainer.appendChild(related);
      }

      if (reviews && bottomDetailsMobile && !bottomDetailsMobile.contains(reviews)) {
        bottomDetailsMobile.appendChild(reviews);
      }
    }
  }

  moveElementsToMobileContainers();
  window.addEventListener('resize', moveElementsToMobileContainers);
});
